import { Grid } from "@mui/material";
import { Client } from "../types";
import ClientDetailsInfos from "./ClientDetailsInfos";
import ClientEditBodyPageUsina from "./ClientEditBodyPageUsina";
import ClientDetailsTableCollaborators from "./ClientDetailsTableCollaborators";

export default function ClientDetailsBodyPage(props: { client: Client | null, onMount: () => void }) {

  return (
    <>
      <ClientDetailsInfos client={props.client} onMount={props.onMount} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <ClientEditBodyPageUsina />
        </Grid>
        {/* <Grid item xs={12} sm={12}>
          <ClientEditBodyPageCollaborators />
        </Grid> */}
        <Grid item xs={12} sm={12}>
          <ClientDetailsTableCollaborators />
        </Grid>
      </Grid>
    </>
  );
}
